import { BrowserModule } from '@angular/platform-browser';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AngularWebStorageModule } from 'angular-web-storage';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Pipe } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { AgmCoreModule } from '@agm/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimeAgoPipe } from 'time-ago-pipe';
import { DatePipe } from '@angular/common';
import { ShareButtonsConfig, ShareModule } from '@ngx-share/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule } from '@angular/common/http';
import { DateTimePickerModule} from 'ngx-datetime-picker';
import { NgxPrintModule } from 'ngx-print';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { TagInputModule } from 'ngx-chips';
import { AppRoutingModule } from './app-routing.module';
import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BarRatingModule } from "ngx-bar-rating";
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ViewComponent } from './view/view.component';
import { SearchComponent } from './search/search.component';
import { SbusinessComponent } from './search/sbusiness/sbusiness.component';
import { VbusinessComponent } from './view/vbusiness/vbusiness.component';
import { CommonPipe } from './_pipe/common.pipe';
import { ImagePipe } from './_pipe/image.pipe';
import { AudioPipe } from './_pipe/audio.pipe';
import { VideoPipe } from './_pipe/video.pipe';
import { IsOwnerPipe } from './_pipe/is-owner.pipe';
import { ColorPickerModule } from 'ngx-color-picker';
import { SblogComponent } from './search/sblog/sblog.component';
import { SearchService } from './_services/search.service';
import { GlobalService } from './_common/global';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateComponent } from './create/create.component';
//import { BusinessComponent } from './create/business/business.component';
import { CbusinessComponent } from './create/cbusiness/cbusiness.component';
import { VblogComponent } from './view/vblog/vblog.component';
import { PageComponent } from './page/page.component';
import { PaboutComponent } from './page/pabout/pabout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { SwiperModule, SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxSelectModule } from 'ngx-select-ex';
import { MyactivityComponent } from './myactivity/myactivity.component';
import { MyComponent } from './my/my.component';
import { LogoutComponent } from './logout/logout.component';
import { MailhomeComponent } from './mailhome/mailhome.component';
import { MphotoComponent } from './my/mphoto/mphoto.component';
import { MvideoComponent } from './my/mvideo/mvideo.component';
import { MblogComponent } from './my/mblog/mblog.component';
import { MeventComponent } from './my/mevent/mevent.component';
import { MbusinessComponent } from './my/mbusiness/mbusiness.component';
import { MaudioComponent } from './my/maudio/maudio.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VphotoComponent } from './view/vphoto/vphoto.component';
import { VvideoComponent } from './view/vvideo/vvideo.component';
import { VaudioComponent } from './view/vaudio/vaudio.component';
import { DreportabuseComponent } from './dialog/dreportabuse/dreportabuse.component';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { CphotoComponent } from './create/cphoto/cphoto.component';
import { CvideoComponent } from './create/cvideo/cvideo.component';
import { CaudioComponent } from './create/caudio/caudio.component';
import { CblogComponent } from './create/cblog/cblog.component';
import { MgroupComponent } from './my/mgroup/mgroup.component';
import { CgroupComponent } from './create/cgroup/cgroup.component';
import { DmemberstatusupdateComponent } from './dialog/dmemberstatusupdate/dmemberstatusupdate.component';
import { DmemberimageupdateComponent } from './dialog/dmemberimageupdate/dmemberimageupdate.component';
import { EphotoComponent } from './edit/ephoto/ephoto.component';
import { EditComponent } from './edit/edit.component';
import { EvideoComponent } from './edit/evideo/evideo.component';
import { EaudioComponent } from './edit/eaudio/eaudio.component';
import { EbusinessComponent } from './edit/ebusiness/ebusiness.component';
import { EblogComponent } from './edit/eblog/eblog.component';
import { EgroupComponent } from './edit/egroup/egroup.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { SphotoComponent } from './search/sphoto/sphoto.component';
import { SvideoComponent } from './search/svideo/svideo.component';
import { SaudioComponent } from './search/saudio/saudio.component';
import { PprivacyComponent } from './page/pprivacy/pprivacy.component';
import { PtosComponent } from './page/ptos/ptos.component';
import { PvideoComponent } from './ui/player/pvideo/pvideo.component';
import { PaudioComponent } from './ui/player/paudio/paudio.component';
import { AvgratingComponent } from './social/avgrating/avgrating.component';
import { RatingComponent } from './social/rating/rating.component';
import { RatingValueComponent } from './social/rating-value/rating-value.component';
import { SocialComponent } from './social/social/social.component';
import { ReviewListComponent } from './review/review-list/review-list.component';
import { UiAppNodataComponent } from './ui/ui-app-nodata/ui-app-nodata.component';
import { UiLoadingSpinnerComponent } from './ui/ui-loading-spinner/ui-loading-spinner.component';
import { UiAppSearchListComponent } from './ui/ui-app-search-list/ui-app-search-list.component';
import { CommentListComponent } from './comment/comment-list/comment-list.component';
import { MalbumComponent } from './my/malbum/malbum.component';
import { MchannelComponent } from './my/mchannel/mchannel.component';
import { MplayListComponent } from './my/mplay-list/mplay-list.component';
import { CalbumComponent } from './create/calbum/calbum.component';
import { CchannelComponent } from './create/cchannel/cchannel.component';
import { CplaylistComponent } from './create/cplaylist/cplaylist.component';
import { ValbumComponent } from './view/valbum/valbum.component';
import { VchannelComponent } from './view/vchannel/vchannel.component';
import { VplayListComponent } from './view/vplay-list/vplay-list.component';
import { EalbumComponent } from './edit/ealbum/ealbum.component';
import { EchannelComponent } from './edit/echannel/echannel.component';
import { EplayListComponent } from './edit/eplay-list/eplay-list.component';
import { DalbumgalleryComponent } from './dialog/dalbumgallery/dalbumgallery.component';
import { SchannelComponent } from './search/schannel/schannel.component';
import { SplaylistComponent } from './search/splaylist/splaylist.component';
import { SalbumComponent } from './search/salbum/salbum.component';
import { PtermsComponent } from './page/pterms/pterms.component';
import { DplaudioeditComponent } from './dialog/dplaudioedit/dplaudioedit.component';
import { DmembereditComponent } from './dialog/dmemberedit/dmemberedit.component';
import { OwlCarouselComponent } from './owl-carousel/owl-carousel.component';
import { UiTagComponent } from './ui/ui-tag/ui-tag.component';
import { UiCategoryComponent } from './ui/ui-category/ui-category.component';
import { SeventComponent } from './search/sevent/sevent.component';
import { CeventComponent } from './create/cevent/cevent.component';
import { ChatsComponent } from './chats/chats.component';
import { DfriendprofileComponent } from './dialog/dfriendprofile/dfriendprofile.component';
import { DchatfriendbuttonsComponent } from './dialog/dchatfriendbuttons/dchatfriendbuttons.component';
import { CchatlistComponent } from './chats/cchatlist/cchatlist.component';
import { PchataudioComponent } from './ui/player/pchataudio/pchataudio.component';
import { PchatvideoComponent } from './ui/player/pchatvideo/pchatvideo.component';
import { FactivitiesComponent } from './friend/factivities/factivities.component';
import { VeventComponent } from './view/vevent/vevent.component';
import { MeducationComponent } from './my/meducation/meducation.component';
import { MsportsComponent } from './my/msports/msports.component';
import { MworkComponent } from './my/mwork/mwork.component';
import { CeducationComponent } from './create/ceducation/ceducation.component';
import { CsportComponent } from './create/csport/csport.component';
import { CworkComponent } from './create/cwork/cwork.component';
import { ChronologymemberComponent } from './chronology/chronologymember/chronologymember.component';
import { VmemberComponent } from './view/vmember/vmember.component';
import { SworkComponent } from './search/swork/swork.component';
import { SeducationComponent } from './search/seducation/seducation.component';
import { SsportsComponent } from './search/ssports/ssports.component';
import { FaudioComponent } from './friend/faudio/faudio.component';
import { FvideoComponent } from './friend/fvideo/fvideo.component';
import { FphotoComponent } from './friend/fphoto/fphoto.component';
import { FblogComponent } from './friend/fblog/fblog.component';
import { FgroupComponent } from './friend/fgroup/fgroup.component';
import { FproductComponent } from './friend/fproduct/fproduct.component';
import { EeventComponent } from './edit/eevent/eevent.component';
import { SproductComponent } from './search/sproduct/sproduct.component';
import { MproductComponent } from './my/mproduct/mproduct.component';
import { CproductComponent } from './create/cproduct/cproduct.component';
import { EproductComponent } from './edit/eproduct/eproduct.component';
import { VproductComponent } from './view/vproduct/vproduct.component';
import { CartlistComponent } from './cart/cartlist/cartlist.component';
import { TopicListComponent } from './topic/topic-list/topic-list.component';
import { PquestionComponent } from './product/pquestion/pquestion.component';
import { PanswerComponent } from './product/panswer/panswer.component';
import { ShareComponent } from './social/share/share.component';
import { AppLeftfilterComponent } from './ui/app-leftfilter/app-leftfilter.component';
import { BcappviewComponent } from './breadcrumb/bcappview/bcappview.component';
import { BcappsearchComponent } from './breadcrumb/bcappsearch/bcappsearch.component';
import { PaymentComponent } from './payment/payment.component';
import { AudiorecordComponent } from './audiorecord/audiorecord.component';
import { Record1Component } from './record1/record1.component';
import { BbusinessComponent } from './view/bbusiness/bbusiness.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { SpollComponent } from './search/spoll/spoll.component';
import { VpollComponent } from './view/vpoll/vpoll.component';
import { PollResultComponent } from './poll-result/poll-result.component';
import { MpollComponent } from './my/mpoll/mpoll.component';
import { CpollComponent } from './create/cpoll/cpoll.component';
import { EpollComponent } from './edit/epoll/epoll.component';
import { DcreatequestionComponent } from './dialog/dcreatequestion/dcreatequestion.component';
import { DcreateanswerComponent } from './dialog/dcreateanswer/dcreateanswer.component';
import { DanswereditComponent } from './dialog/dansweredit/dansweredit.component';
import { TappsComponent } from './timeline/tapps/tapps.component';
import { BtimelineComponent } from './breadcrumb/btimeline/btimeline.component';
import { MyappsearchComponent } from './breadcrumb/myappsearch/myappsearch.component';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: 'horizontal',
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  centeredSlides: true
};
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: '/supload/hhjjj',
  paramName: 'uploadfile',
  maxFilesize: 20,   
};
const customConfig: ShareButtonsConfig = {
  autoSetMeta: true,
  theme: 'circles-dark',
  twitterAccount: 'rockland'
};

@NgModule({
  declarations: [
    TimeAgoPipe,
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    ViewComponent,
    SearchComponent,
    SbusinessComponent,
    VbusinessComponent,
    CommonPipe,
    ImagePipe,
    AudioPipe,
    VideoPipe,
    IsOwnerPipe,
    SblogComponent,
    CreateComponent,
    CbusinessComponent,
    VblogComponent,
    PageComponent,
    PaboutComponent,
    LoginComponent,
    RegisterComponent,
    MyactivityComponent,
    MyComponent,
    LogoutComponent,
    MailhomeComponent,
    MphotoComponent,
    MvideoComponent,
    MblogComponent,
    MeventComponent,
    MbusinessComponent,
    MaudioComponent,
    ForgotPasswordComponent,
    VphotoComponent,
    VvideoComponent,
    VaudioComponent,
    DreportabuseComponent,
    CphotoComponent,
    CvideoComponent,
    CaudioComponent,
    CblogComponent,
    MgroupComponent,
    CgroupComponent,
    DmemberstatusupdateComponent,
    DmemberimageupdateComponent,
    EphotoComponent,
    EditComponent,
    EvideoComponent,
    EaudioComponent,
    EbusinessComponent,
    EblogComponent,
    EgroupComponent,
    SphotoComponent,
    SvideoComponent,
    SaudioComponent,
    PprivacyComponent,
    PtosComponent,
    PvideoComponent,
    PaudioComponent,
    AvgratingComponent,
    RatingComponent,
    RatingValueComponent,
    SocialComponent,
    ReviewListComponent,
    UiAppNodataComponent,
    UiLoadingSpinnerComponent,
    UiAppSearchListComponent,
    CommentListComponent,
    MalbumComponent,
    MchannelComponent,
    MplayListComponent,
    CalbumComponent,
    CchannelComponent,
    CplaylistComponent,
    ValbumComponent,
    VchannelComponent,
    VplayListComponent,
    EalbumComponent,
    EchannelComponent,
    EplayListComponent,
    DalbumgalleryComponent,
    SchannelComponent,
    SplaylistComponent,
    SalbumComponent,
    PtermsComponent,
    DplaudioeditComponent,
    DmembereditComponent,
    OwlCarouselComponent,
    UiTagComponent,
    UiCategoryComponent,
    SeventComponent,
    CeventComponent,
    ChatsComponent,
    DfriendprofileComponent,
    DchatfriendbuttonsComponent,
    CchatlistComponent,
    PchataudioComponent,
    PchatvideoComponent,
    FactivitiesComponent,
    VeventComponent,
    MeducationComponent,
    MsportsComponent,
    MworkComponent,
    CeducationComponent,
    CsportComponent,
    CworkComponent,
    ChronologymemberComponent,
    VmemberComponent,
    SworkComponent,
    SeducationComponent,
    SsportsComponent,
    FaudioComponent,
    FvideoComponent,
    FphotoComponent,
    FblogComponent,
    FgroupComponent,
    FproductComponent,
    EeventComponent,
    SproductComponent,
    MproductComponent,
    CproductComponent,
    EproductComponent,
    VproductComponent,
    CartlistComponent,
    TopicListComponent,
    PquestionComponent,
    PanswerComponent,
    ShareComponent,
    AppLeftfilterComponent,
    BcappviewComponent,
    BcappsearchComponent,
    PaymentComponent,
    AudiorecordComponent,
    Record1Component,
    BbusinessComponent,
    GetStartedComponent,
    SpollComponent,
    VpollComponent,
    PollResultComponent,
    MpollComponent,
    CpollComponent,
    EpollComponent,
    DcreatequestionComponent,
    DcreateanswerComponent,
    DanswereditComponent,
    TappsComponent,
    BtimelineComponent,
    MyappsearchComponent
  ],
  imports: [
    BarRatingModule,
    TagInputModule,
    ShareModule.withConfig(customConfig),
    FontAwesomeModule,
    NgxSmartModalModule.forRoot(),
    ScrollToModule.forRoot(),
    InfiniteScrollModule,
    AngularWebStorageModule,
    NgxSelectModule,
    BrowserModule,
    SwiperModule,
    EditorModule,
    CarouselModule,
    BrowserAnimationsModule,
    AutocompleteLibModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAxmGxu4VcwxQYR6jGZta2BVDVKHKx4YQU',
      libraries: ["places"]
    }),
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    AutocompleteLibModule,
    HttpClientModule,
    DateTimePickerModule,
    TooltipModule,
    ModalModule.forRoot(),
    NgxPrintModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    FormsModule,
    ColorPickerModule,
    DropzoneModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    AppRoutingModule
  ],
  providers: [{
    provide: DROPZONE_CONFIG,
    useValue: DEFAULT_DROPZONE_CONFIG
  }, DatePipe, SearchService, CommonPipe, GlobalService, NgxSmartModalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
